// import React from "react";
// import { Link } from "react-router-dom";
// import { Linkedin, Twitter, Facebook, Instagram, Github, Mail, Globe } from "lucide-react";
// import { LOGO_URL, BRAND, NAV_LINKS } from "../lib/constants";

// const socials = [
//   { name: "LinkedIn", href: "https://linkedin.com", Icon: Linkedin },
//   { name: "X", href: "https://x.com", Icon: Twitter },
//   { name: "Facebook", href: "https://facebook.com", Icon: Facebook },
//   { name: "Instagram", href: "https://instagram.com", Icon: Instagram },
//   { name: "GitHub", href: "https://github.com", Icon: Github },
// ];

// export const Footer = () => {
//   return (
//     <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
//       <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
//         <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
//           <div className="md:col-span-5">
//             <Link to="/" className="flex items-center gap-3">
//               <img src={LOGO_URL} alt="JustZeta" className="h-11 w-11 object-contain" />
//               <span className="font-serif-display text-3xl text-white">{BRAND.name}</span>
//             </Link>
//             <p className="mt-6 text-neutral-400 max-w-sm leading-relaxed">
//               {BRAND.tagline}
//             </p>
//             {/* <div className="mt-8 flex items-center gap-5">
//               {socials.map(({ name, href, Icon }) => (
//                 <a
//                   key={name}
//                   href={href}
//                   target="_blank"
//                   rel="noreferrer"
//                   aria-label={name}
//                   data-testid={`footer-social-${name.toLowerCase()}`}
//                   className="text-neutral-500 hover:text-[#e60000] transition-colors"
//                 >
//                   <Icon size={18} strokeWidth={1.5} />
//                 </a>
//               ))}
//             </div> */}
//           </div>

//           <div className="md:col-span-3">
//             <div className="overline mb-6">Navigate</div>
//             <ul className="space-y-3">
//               {NAV_LINKS.map((l) => (
//                 <li key={l.to}>
//                   <Link
//                     to={l.to}
//                     data-testid={`footer-link-${l.label.toLowerCase()}`}
//                     className="text-neutral-300 hover:text-white text-[15px] hover-underline"
//                   >
//                     {l.label}
//                   </Link>
//                 </li>
//               ))}
//               <li>
//                 <Link to="/privacy" data-testid="footer-link-privacy" className="text-neutral-300 hover:text-white text-[15px] hover-underline">
//                   Privacy Policy
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/terms" data-testid="footer-link-terms" className="text-neutral-300 hover:text-white text-[15px] hover-underline">
//                   Terms &amp; Conditions
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           <div className="md:col-span-4">
//             <div className="overline mb-6">Contact</div>
//             <ul className="space-y-4 text-neutral-300 text-[15px]">
//               <li className="flex items-start gap-3">
//                 <Globe size={16} className="mt-1 text-neutral-500" />
//                 <a href={BRAND.website} target="_blank" rel="noreferrer" className="hover-underline">
//                   {BRAND.website.replace("https://", "")}
//                 </a>
//               </li>
//               <li className="flex items-start gap-3">
//                 <Mail size={16} className="mt-1 text-neutral-500" />
//                 <a href={`mailto:${BRAND.email}`} className="hover-underline">
//                   {BRAND.email}
//                 </a>
//               </li>
//             </ul>
//             <div className="mt-10 border border-white/10 p-6">
//               <div className="overline mb-2">Archival integrity</div>
//               <p className="text-sm text-neutral-400">
//                 Preserved with encrypted, redundant cloud infrastructure — engineered for
//                 decade-long retention.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
//           <p className="text-xs text-neutral-500 tracking-wide">
//             &copy; 2026 {BRAND.name}. All Rights Reserved.
//           </p>
//           <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-600">
//             Built for permanence · v1.0
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Facebook, Instagram, Github, Mail, Globe } from "lucide-react";
import { LOGO_URL, BRAND, NAV_LINKS } from "../lib/constants";

const socials = [
  { name: "LinkedIn", href: "https://linkedin.com", Icon: Linkedin },
  { name: "X", href: "https://x.com", Icon: Twitter },
  { name: "Facebook", href: "https://facebook.com", Icon: Facebook },
  { name: "Instagram", href: "https://instagram.com", Icon: Instagram },
  { name: "GitHub", href: "https://github.com", Icon: Github },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="JustZeta" className="h-11 w-11 object-contain" />
              <span className="font-serif-display text-3xl text-white">{BRAND.name}</span>
            </Link>
            <p className="mt-6 text-neutral-400 max-w-sm leading-relaxed">
              {BRAND.tagline}
            </p>
            {/* <div className="mt-8 flex items-center gap-5">
              {socials.map(({ name, href, Icon }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={name}
                  data-testid={`footer-social-${name.toLowerCase()}`}
                  className="text-neutral-500 hover:text-[#e60000] transition-colors"
                >
                  <Icon size={18} strokeWidth={1.5} />
                </a>
              ))}
            </div> */}
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-6">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-neutral-300 hover:text-white text-[15px] hover-underline"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/privacy" data-testid="footer-link-privacy" className="text-neutral-300 hover:text-white text-[15px] hover-underline">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-link-terms" className="text-neutral-300 hover:text-white text-[15px] hover-underline">
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-6">Contact</div>
            <ul className="space-y-4 text-neutral-300 text-[15px]">
              <li className="flex items-start gap-3">
                <Globe size={16} className="mt-1 text-neutral-500" />
                <a href={BRAND.website} target="_blank" rel="noreferrer" className="hover-underline">
                  {BRAND.website.replace("https://", "")}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-1 text-neutral-500" />
                <a href={`mailto:${BRAND.email}`} className="hover-underline">
                  {BRAND.email}
                </a>
              </li>
            </ul>
         <div className="mt-10 border border-white/10 p-6">
  <div className="overline mb-2">Enterprise Security</div>
  <p className="text-sm leading-relaxed text-neutral-400">
    JustZeta is designed with modern security practices, encrypted data transmission, secure
    authentication, and comprehensive auditability to safeguard organizational
    information.
  </p>
</div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-neutral-500 tracking-wide">
            &copy; 2026 {BRAND.name}. All Rights Reserved.
          </p>
          <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-600">
          Trusted Digital Document Management · v1.0
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;